import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'
import { Collapse } from 'react-bootstrap'
import Search from './filters/search'
import ViewType from './filters/view_type'
import AdvancedFiltersToggle from './filters/advanced_filters_toggle'
import TourFilter from './filters/tour_filter'
import EventStatusFilter from './filters/event_status_filter'
import StartDateFilter from './filters/start_date_filter'
import EndDateFilter from './filters/end_date_filter'
import LocationFilter from './filters/location_filter'
import { useEffect } from 'react'
import { filter } from 'lodash'

const DirectoriesFiltersComponent = (props) => {
  const {
    viewType, advancedFiltersOn, changeFilter, toursOptions, showTours, selectedTour, leagueName, selectedEventStatus, statusFilterVisible,
    startDate, endDate, location, showLocationFilter, currentLocation, metricUnits, shouldShowLotteryFilter, customerDateFormat, fetchFilteredData, filteredDataIsLoading, initialFiltersLoaded
  } = props

  const colSize = showTours ? 3 : 4
  const tourDisabled = false

  useEffect(() => {
    if (!initialFiltersLoaded) {
      return
    }
    const timeoutId = setTimeout(() => {
      fetchFilteredData()
    }, 1000)
    return () => {
      clearTimeout(timeoutId)
    }
  }, [selectedEventStatus, startDate, endDate, location, selectedTour, leagueName])

  return (
    <div className="categories-filters">
      <Row className="padding-0">
        <Col xs={12} sm={1} md={2} lg={1} xl={1} className="hidden-directories-xs">
          <AdvancedFiltersToggle open={advancedFiltersOn} onChange={changeFilter} disabled={filteredDataIsLoading} />
        </Col>
        <Col className="hidden-xs" md={1} mdOffset={1} lg={2} />
        <Col xs={12} sm={3} smOffset={1} mdOffset={0} md={3} lg={2} xl={2} className="view-types-and-toggle hidden-directories-xs">
          <Col sm={7} smOffset={3} md={7} mdOffset={0} xs={8} className="view-types-and-toggle hidden-directories-xs">
            <ViewType viewType={viewType} onChange={changeFilter} disabled={filteredDataIsLoading} />
          </Col>
        </Col>
        <Col xs={4} sm={1} md={1} lg={5} xl={6} className="visible-directories-xs add-margin-top-5">
          <AdvancedFiltersToggle open={advancedFiltersOn} onChange={changeFilter} disabled={filteredDataIsLoading} />
        </Col>
        <Col xs={8} sm={7} md={5} lg={5} xl={6}>
          <Search value={leagueName} onChange={changeFilter} disabled={filteredDataIsLoading} />
        </Col>
      </Row>

      <Collapse in={advancedFiltersOn}>
        <div className="transition-wrapper">
          <Row className="padding-0">
            <Col xs={12} sm={colSize} md={colSize} lg>
              <EventStatusFilter
                values={selectedEventStatus}
                onChange={changeFilter}
                fetchFilteredData={fetchFilteredData}
                statusFilterVisible={statusFilterVisible}
                showTours={showTours}
                shouldShowLotteryFilter={shouldShowLotteryFilter}
                disabled={filteredDataIsLoading}
              />
            </Col>
            {showTours && (
              <Col xs={12} sm={colSize} md={colSize} lg>
                <TourFilter
                  toursOptions={toursOptions}
                  value={selectedTour}
                  onChange={changeFilter}
                  disabled={tourDisabled || filteredDataIsLoading}
                />
              </Col>
            )}
            <Col xs={6} sm={colSize} md={colSize} lg>
              <StartDateFilter onChange={changeFilter} value={startDate} customerDateFormat={customerDateFormat} disabled={filteredDataIsLoading} />
            </Col>
            <Col xs={6} sm={colSize} md={colSize} lg>
              <EndDateFilter onChange={changeFilter} value={endDate} disabled={filteredDataIsLoading} />
            </Col>
          </Row>
          <Row className="padding-0">
            <Col xs={12}>
              <LocationFilter
                onChange={changeFilter}
                value={location}
                allDataIsLoading={tourDisabled}
                showLocationFilter={showLocationFilter}
                currentLocation={currentLocation}
                metricUnits={metricUnits}
                disabled={filteredDataIsLoading}
              />
            </Col>
          </Row>
        </div>
      </Collapse>
    </div>
  )
}

DirectoriesFiltersComponent.propTypes = {
  viewType: PropTypes.string.isRequired,
  advancedFiltersOn: PropTypes.bool.isRequired,
  changeFilter: PropTypes.func.isRequired,
  toursOptions: PropTypes.array.isRequired,
  showTours: PropTypes.bool.isRequired,
  selectedTour: PropTypes.string.isRequired,
  leagueName: PropTypes.string.isRequired,
  selectedEventStatus: PropTypes.array.isRequired,
  statusFilterVisible: PropTypes.bool.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  location: PropTypes.string,
  showLocationFilter: PropTypes.bool,
  currentLocation: PropTypes.string,
  metricUnits: PropTypes.bool,
  shouldShowLotteryFilter: PropTypes.bool,
  customerDateFormat: PropTypes.string.isRequired,
  filteredDataIsLoading: PropTypes.bool,
  initialFiltersLoaded: PropTypes.bool.isRequired,
}

export default DirectoriesFiltersComponent